import { fetcher } from '@/plugins/request';

// 获取订单列表
export function getOrderList(params) {
  return fetcher({
    url: '/order/list',
    method: 'post',
    data: params,
  });
}

// 更新订单
export function orderEdit(params) {
  return fetcher({
    url: '/order/edit',
    method: 'post',
    data: params,
  });
}
